module.exports = __webpack_public_path__ + "media/images/lp_v6_reserve_bg_sp-d18964f3ae27cdf2c3def67a5b8e82a0.webp";